<template>
  <div class="basic-block block-another-fortune-num" v-if="fortuneNum">
    <div class="content-wrap">
      <div class="block-another-fortune-num__inner">
        <p class="head-text">あと…実はあなたの中には<br><span class="more-num">もう１つの暴露数</span>があるんです</p>
        <span class="attention">※暴露数が１つめと同じ場合もあります</span>
        <div class="block-another-fortune-num__contents">
          <h3>あなたのもう１つの暴露数は…</h3>
          <img :src="secondFortuneNumImgMod" alt="" class="your-another-num">
          <p>２つの暴露数は、<br>状況によって表に出てくる個性が違います</p>
          <img  class="number-image" src="/static/img/recommend/lp/houen/bakuronum.gif" alt="">
          <p class="point">いま占いTVに入会すると<br>暴露数鑑定書が作れます！</p>
          <lp-base-button
            label="登録して見る"
            design="fill"
            :color-scheme="colorScheme"
            class="block-uranaitv-desc-2__point-btn"
            @clicked="onSubscrBtnClick('ResultAnotherBakuro')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockLinkInput',
  components: {
    LpBaseButton,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    fortuneNum: {
      type: Number,
      default: 0,
    },
    secondFortuneNumImg: {
      type: String,
      default: '',
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: String,
  },
  computed: {
    secondFortuneNumImgMod(){
      return this.secondFortuneNumImg
      //return 'https://uranaitv-store-imglogic.s3.ap-northeast-1.amazonaws.com/reco/free/4/mitsuri/1.jpg'
    }
  },
  methods: {
    onSubscrBtnClick(val){
      const payload = {
        link: this.subscUrl,
        param: {
          'event_category': `LP${this.lpId}-subsc-button`,
          'event_label': `${val}`
        }
      }
      // this.$emit('link', payload)
      window.gtag('event', 'click', payload.param)
      location.href = this.$handoverParams(payload.link)
    },

  },
  
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-another-fortune-num {
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  background: #fffbe3;
  padding: 0 0 20px;
  &__inner {
    margin: 0 20px;
    padding: 40px 0px 24px;
    background: #fff;
    p {
      font-weight: normal;
      .fortune-num {
        color: #4d89c4;
        font-weight: bold;
        .num {
          margin: 0 2px;
        }
      }
    }
    .attention {
      font-weight: normal;
      font-size: 12px;
    }
  }
  &__contents{
    border: 1px solid #00462e;
    border-radius: 10px;   
    padding: 24px 20px; 
    margin-top: 24px;
    img{
      width: 100%;
    }
    h3{
      font-family: 'Hiragino Kaku Gothic Pro';
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: #00462e;
    }
    p{
      margin:0;
      margin-bottom: 16px;
    }
    

  }
  .number-image{
    margin-bottom:16px;
  }
  .your-another-num{
    margin-bottom: 16px;
  }
  .point{
    font-family: 'Hiragino Kaku Gothic Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    margin: 0;
    text-align: center;
    color: #00462e;
    margin-bottom: 16px;
  }
  .more-num{
    background:#00462e;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
  .head-text{
    font-family: 'Hiragino Kaku Gothic Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #32373f;
    margin-bottom: 0;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockAnotherFotuneNum2.vue